<script setup lang="ts">
  import { computed, useAttrs } from 'vue';

  defineOptions({
    inheritAttrs: false,
  });

  const props = defineProps<{
    src: string | object;
    alt: string;
  }>();

  const attrs = useAttrs();

  const iconComponent = computed(() => {
    return props.src;
  });
</script>
<template>
  <component
    :is="iconComponent"
    v-bind="attrs"
    :alt="alt"
  />
</template>
